var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneySelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fefefe;\n        stroke: #114b83;\n        stroke-miterlimit: 10;\n        stroke-width: 12.57px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M268.74,102.36v33.85c36.51,3.09,61.9,35.27,60.5,71.3h-52.57c.42-11.64-3.29-27.99-15.85-32.04-29.09-9.38-40.21,30.01-17.23,46.04,27.41,19.12,69.99,22.52,81.7,61.62,12.64,42.19-12.92,76.52-54.83,82.74-1.16.17-5.31-.22-5.31,1.17v30.61h-24.49v-31.69c-41.11-1.84-71.8-33.13-69.86-74.9h51.49c1.66,0,.93,6.12,1.09,7.55,2.2,19.73,13.93,30.5,34.19,28.45,20.42-2.07,23.12-30.99,11.2-43.59-9.97-10.55-38.95-18.89-53.09-26.85-26.47-14.91-40.66-36.65-36.16-68.09,4.59-32.06,33.06-51.28,64.01-53.02v-33.13h25.21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneySelected);
export default __webpack_public_path__ + "static/media/money-selected.0f51ae242db1451cc23c7014101dc16f.svg";
export { ForwardRef as ReactComponent };